import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ requiredLevel }) => {
  const account = JSON.parse(localStorage.getItem("account"));

  if (!account) {
    return <Navigate to="/" replace />;
  }

  if (account.level > requiredLevel) {
    return <Navigate to="/" replace />;
  }

  // Otherwise, allow access
  return <Outlet />;
};

export default ProtectedRoute;
